import { autoserialize, autoserializeAs } from 'cerialize';
import { ServiceLevel } from './service-level';

export class OrganizationRiderServiceLevel {
  @autoserialize
  organizationRiderId: number;

  @autoserializeAs(ServiceLevel)
  serviceLevel: ServiceLevel;

  @autoserialize
  enabled: boolean;
}
